import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import Home from './components/home/Home';
import About from './components/about/About';
import AboutActivities from './components/about/AboutActivities';
import AboutAmbassadors from './components/about/AboutAmbassadors';
import Tour from './components/tour/Tour';
import TourReviews from './components/tour/TourReviews';
import Guide from './components/guide/Guide';
import GuideLife from './components/guide/GuideLife';
import GuideAcademics from './components/guide/GuideAcademics_01';
import GuideAdvice from './components/guide/GuideAdvice';
import './styles/global.scss';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/about/activities" element={<AboutActivities />} />
            <Route path="/about/ambassadors" element={<AboutAmbassadors />} />
            <Route path="/tour" element={<Tour />} />
            <Route path="/tour/reviews" element={<TourReviews />} />
            <Route path="/guide" element={<Guide />} />
            <Route path="/guide/life" element={<GuideLife />} />
            <Route path="/guide/academics" element={<GuideAcademics />} />
            <Route path="/guide/advice" element={<GuideAdvice />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}


export default App;
